var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"table_wrapper"},[_c('table',{staticClass:"qb-table vs-table vs-table--tbody-table striped-table permit-table",style:({ overflow: 'auto', height: 'auto' }),attrs:{"id":_vm.tableId}},[_c('thead',[_vm._t("thead")],2),_c('tbody',{staticStyle:{"overflow":"auto"}},[_vm._t("tbody")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }